'use client';
/* eslint-disable */

import {
   Box,
   Button,
   Flex,
   IconButton,
   Table,
   Tbody,
   Td,
   Text,
   Th,
   Thead,
   Tr,
   useColorModeValue,
   useDisclosure,
   Select,
   Grid,
   useOutsideClick,
   useBreakpointValue,
   useColorMode,
} from '@chakra-ui/react';
import { DeleteIcon, EditIcon } from '@chakra-ui/icons';
import {
   createColumnHelper,
   flexRender,
   getCoreRowModel,
   getSortedRowModel,
   useReactTable,
} from '@tanstack/react-table';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
import React, { useEffect, useState, useRef } from 'react';
import Card from 'components/card/Card';
import Menu from 'components/menu/MainMenu';
import { SearchBar } from 'components/navbar/searchBar/SearchBar';
import BrandMasterForm from './BrandMasterForm';
import { useDispatch, useSelector } from 'react-redux';
import { renderFormControl } from '../../../../../utils/DynamicFormData';
import { deleteBrand, getBrand, getSingleBrand } from '../../../../../redux/actions/brand';
import DeleteDialog from '../../components/DeleteDialog';
import ViewSingleData from '../../components/ViewSingleData';
import { MdNavigateNext, MdNavigateBefore } from 'react-icons/md';
import DynamicTable from '../../components/DynamicAllDataTable';
import MobileDataTable from '../../components/MobileDataTable';
import { useGlobal } from '../../../../../contexts';

// filter
import filter from 'assets/img/nfts/filter.svg';
import filter1 from 'assets/img/nfts/filter1.svg';
import nodata from 'assets/img/nfts/no data.svg';
import { GridItem, Input, FormLabel } from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';
import { motion } from 'framer-motion';
import { useUser } from 'contexts';
import Loader from 'views/admin/default/Loader';
//filter end

const columnHelper = createColumnHelper();
const MotionFlex = motion(Flex);
const MotionSearchIcon = motion(SearchIcon);

export default function BrandMaster({ columnsData }) {
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const [sorting, setSorting] = React.useState([]);
   const dispatch = useDispatch();
   const brandData = useSelector((state) => state.brand.list || []);
   const pagination = useSelector((state) => state.brand.pagination || []);
   const [data, setData] = React.useState([...brandData]);
   const [currentRow, setCurrentRow] = React.useState(null);
   const [focusedInput, setFocusedInput] = React.useState(null);
   const [limit, setLimit] = React.useState(10);
   const [currentPage, setCurrentPage] = React.useState(1);
   const [searchQuery, setSearchQuery] = React.useState('');
   const [isLoading, setIsLoading] = useState(false);
   const [debouncedSearchQuery, setDebouncedSearchQuery] = React.useState('');
   const { isOpen, onOpen, onClose } = useDisclosure();
   const [isDeleteDialogOpen, setDeleteDialogOpen] = React.useState(false); // State to manage delete confirmation
   const [selectedRowId, setSelectedRowId] = React.useState(null);
   const [isEditMode, setIsEditMode] = React.useState(false);
   const [isOpenSingleView, setIsOpenSingleView] = React.useState(false);
   const bg = useColorModeValue('#f2f7f2', '#1a254b');
   const icon = useColorModeValue('#000000', '#ffffff');
   const [isEditingPage, setIsEditingPage] = useState(false);
   const [pageInputValue, setPageInputValue] = useState('');
   const singleEntity = useSelector((state) => state?.customer?.single || {});
   const isMobileOrTablet = useBreakpointValue({ base: true, md: false, lg: false });
   const isDesktop = useBreakpointValue({ base: false, md: true });
   const { user } = useUser();
   const Admin = user?.isAdmin;

   const { userGlobalSettingsData } = useGlobal();
   const globalSetting = userGlobalSettingsData?.[0]?.askCompany?.brand;
   const shouldShowCompanyDropdown = globalSetting || false;

   const companyId = Number(localStorage.getItem('companyId'));
   const brandRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === companyId)?.brand
      : null;

   useEffect(() => {
      setCurrentPage(1); // Reset to page 1 whenever searchQuery changes
   }, [searchQuery]);

   useEffect(() => {
      const handleKeyDown = (e) => {
         const activeElement = document.activeElement;
         const isTyping =
            activeElement?.tagName === 'INPUT' ||
            activeElement?.tagName === 'TEXTAREA' ||
            activeElement?.getAttribute('role') === 'textbox' ||
            activeElement?.isContentEditable;

         if (isTyping) return;

         if (e.key.toLowerCase() === 'n' || e.key === '+') {
            if (!isOpen && !isOpenSingleView && (Admin || brandRight?.add) && user && !user.isExpired) {
               e.preventDefault();
               setCurrentRow({});
               setIsEditMode(false);
               onOpen();
            }
         }
      };

      window.addEventListener('keydown', handleKeyDown);

      return () => {
         window.removeEventListener('keydown', handleKeyDown);
      };
   }, [!isOpen, !isOpenSingleView, Admin, brandRight?.add]);

   useEffect(() => {
      const fetchMainData = async () => {
         try {
            setIsLoading(true);
            await dispatch(
               getBrand({
                  page: currentPage,
                  // limit: limit === pagination?.totalProducts ? undefined : limit, // undefined fetches everything
                  search: debouncedSearchQuery,
                  sortBy: sorting.length ? sorting[0]?.name : 'name',
                  sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'asc',
                  ...(shouldShowCompanyDropdown && { companyIds: user?.loginhistory?.companyId }),
               }),
            );
         } catch (error) {
            console.error('Error fetching main data:', error);
         } finally {
            setIsLoading(false);
         }
      };

      fetchMainData();
   }, [dispatch, currentPage, limit, debouncedSearchQuery, sorting]);

   const handlePageChange = (directionOrPage) => {
      if (typeof directionOrPage === 'number') {
         // Direct page number navigation
         setCurrentPage(directionOrPage);
      } else {
         // Previous/next navigation
         const newPage = directionOrPage === 'next' ? pagination.nextPage : pagination.previousPage;
         if (newPage) setCurrentPage(newPage);
      }
   };

   const handlePageClick = () => {
      setIsEditingPage(true);
      setPageInputValue(''); // Clear input value when starting to edit
   };

   const handlePageInputSubmit = () => {
      const page = parseInt(pageInputValue);
      if (!isNaN(page) && page >= 1 && page <= pagination?.totalPages) {
         handlePageChange(page);
      }
      setIsEditingPage(false);
      setPageInputValue('');
   };

   const handlePageInputBlur = () => {
      handlePageInputSubmit();
   };

   const handlePageKeyDown = (e) => {
      if (e.key === 'Enter') {
         handlePageInputSubmit();
      } else if (e.key === 'Escape') {
         setIsEditingPage(false);
         setPageInputValue('');
      }
   };

   const handlePageSizeChange = (e) => {
      const value = e.target.value;

      // If "ALL" is selected, set limit to null or totalProducts to fetch everything
      const newLimit = value === 'ALL' ? pagination?.totalProducts : Number(value);

      setLimit(newLimit);
      setCurrentPage(1); // Reset to page 1 to avoid offset issues
   };

   const paginatedData = React.useMemo(() => {
      if (limit === pagination?.totalProducts) return brandData;

      if (!Array.isArray(brandData) || brandData.length === 0) {
         return [];
      }
      return brandData;
   }, [brandData, pagination?.currentPage, limit, pagination?.totalProducts]);

   // useEffect(() => {
   //   setData([...brandData]);
   // }, [brandData]);

   const handleDelete = async () => {
      if (selectedRowId !== null) {
         try {
            await dispatch(deleteBrand(selectedRowId, companyId));
            setData(data.filter((row) => row.id !== selectedRowId));
            setDeleteDialogOpen(false); // Close the dialog after deletion
         } catch (err) {
            // console.error("Failed to delete brand:", err);
         }
      }
   };

   const handleDeleteClick = (id) => {
      setSelectedRowId(id);
      setDeleteDialogOpen(true);
   };

   const filteredData = React.useMemo(() => {
      if (!searchQuery) return data;
      return data?.filter((row) =>
         columnsData?.some((col) => String(row[col.id]).toLowerCase().includes(searchQuery.toLowerCase())),
      );
   }, [data, searchQuery, columnsData]);

   const handleFocus = (id) => setFocusedInput(id);
   const handleBlur = () => setFocusedInput(null);
   const [columnVisibility, setColumnVisibility] = React.useState(
      columnsData.reduce((acc, column) => {
         acc[column.id] = true;
         return acc;
      }, {}),
   );

   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');

   const columns = columnsData
      .filter((column) => columnVisibility[column.id])
      .map((column) =>
         columnHelper.accessor(column.id, {
            id: column.id,
            header: () => (
               <Text justifyContent="space-between" align="center" fontSize={{ sm: '10px', lg: '12px' }}>
                  {column.header}
               </Text>
            ),
            cell: (info) => <Flex align="center">{info.getValue()}</Flex>,
         }),
      );

   columns.push(
      columnHelper.accessor('id', {
         id: 'id',
         header: () => null,
         cell: (info) => (
            <Flex justify="end">
               <Box className="edit-icon-container">
                  <IconButton
                     aria-label="Edit"
                     icon={<EditIcon />}
                     variant="ghost"
                     colorScheme="brand"
                     onClick={(e) => {
                        e.stopPropagation(); // Prevent the table row click event from being triggered
                        setCurrentRow(info.row);
                        setIsEditMode(true);
                        onOpen();
                        setIsOpenSingleView(false);
                     }}
                  />
                  <IconButton
                     aria-label="Delete"
                     icon={<DeleteIcon />}
                     variant="ghost"
                     colorScheme="red"
                     onClick={(e) => {
                        e.stopPropagation(); // Prevent the table row click event from being triggered
                        handleDeleteClick(info.row.id);
                        setIsOpenSingleView(false);
                     }}
                  />
               </Box>
            </Flex>
         ),
      }),
   );

   const table = useReactTable({
      data,
      columns,
      state: { sorting },
      onSortingChange: setSorting,
      getCoreRowModel: getCoreRowModel(),
      getSortedRowModel: getSortedRowModel(),
   });

   const handleSave = (formData) => {
      if (isEditMode && currentRow) {
         setData(data.map((row) => (row.id === currentRow.id ? { ...currentRow, ...formData } : row)));
      } else if (!isEditMode) {
         setData([...data, { ...formData, id: Date.now() }]);
      }
      dispatch(
         getBrand({
            page: currentPage,
            // limit: limit === pagination?.totalProducts ? undefined : limit, // undefined fetches everything
            search: debouncedSearchQuery,
            sortBy: sorting.length ? sorting[0]?.name : 'name',
            sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'asc',
            ...(shouldShowCompanyDropdown && { companyIds: user?.loginhistory?.companyId }),
         }),
      );
      onClose();
   };

   const downloadPDF = () => {
      const doc = new jsPDF();
      const visibleColumns = columnsData.filter((col) => columnVisibility[col.id]).map((col) => col.header);

      const dataToExport = data.map((row) =>
         visibleColumns.map((header) => row[columnsData.find((col) => col.header === header).id]),
      );

      doc.autoTable({
         head: [visibleColumns],
         body: dataToExport,
      });

      doc.save('data.pdf');
   };

   const downloadExcel = () => {
      const workbook = XLSX.utils.book_new();

      const visibleColumns = columnsData.filter((col) => columnVisibility[col.id]).map((col) => col.header);

      const dataToExport = data.map((row) =>
         visibleColumns.map((header) => row[columnsData.find((col) => col.header === header).id]),
      );

      const worksheetData = [visibleColumns, ...dataToExport];

      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

      XLSX.writeFile(workbook, 'data.xlsx');
   };

   const handleViewSingleData = async (id) => {
      await dispatch(getSingleBrand(id));
      setIsOpenSingleView(true);
   };
   var dynamicArray = [];
   dynamicArray = [
      { label: 'Name', value: singleEntity?.name },
      { label: 'Email', value: singleEntity?.email },
      { label: 'Mobile', value: singleEntity?.mobile },
      {
         label: 'Address',
         value:
            singleEntity?.accountaddress && singleEntity.accountaddress.length > 0
               ? singleEntity.accountaddress[0]?.address1
               : '-',
      },
      {
         label: 'GSTIN',
         value:
            singleEntity?.accountaddress && singleEntity.accountaddress.length > 0
               ? singleEntity.accountaddress[0]?.gst
               : '-',
      },
      {
         label: 'City',
         value:
            singleEntity?.accountaddress && singleEntity.accountaddress.length > 0
               ? singleEntity.accountaddress[0]?.city
               : '-',
      },
      {
         label: 'State',
         value:
            singleEntity?.accountaddress && singleEntity.accountaddress.length > 0
               ? singleEntity.accountaddress[0]?.state
               : '-',
      },
      {
         label: 'Country',
         value:
            singleEntity?.accountaddress && singleEntity.accountaddress.length > 0
               ? singleEntity.accountaddress[0]?.country
               : '-',
      },
      {
         label: 'Pincode',
         value:
            singleEntity?.accountaddress && singleEntity.accountaddress.length > 0
               ? singleEntity.accountaddress[0]?.pincode
               : '-',
      },
   ];

   const debounce = (func, delay) => {
      let timer;
      return function (...args) {
         clearTimeout(timer);
         timer = setTimeout(() => func.apply(this, args), delay);
      };
   };

   const debouncedSearchHandler = React.useCallback(
      debounce((query) => {
         setDebouncedSearchQuery(query);
      }, 500),
      [],
   );

   // Handle search input changes
   const handleSearchChange = (e) => {
      const value = e.target.value.trimStart();
      setSearchQuery(value);
      debouncedSearchHandler(value);
   };

   // --------------------- filter --------------------- //
   const backgroundColor = useColorModeValue('white', 'rgba(12, 20, 41, 1)');

   const [selectedFilter, setSelectedFilter] = useState(''); // Stores selected filter type
   const [NameselectedFilter, setNameselectedFilter] = useState('');
   const [ordinalselectedFilter, setordinalselectedFilter] = useState('');

   const [inputValue, setInputValue] = useState('');
   const [NameInputValue, setNameInputValue] = useState(''); // Stores input value
   const [ordinalInputValue, setordinalInputValue] = useState('');
   const [addedName, setAddedName] = useState(''); // Stores final displayed value

   const [BrandData, setBrandData] = useState([]);

   useEffect(() => {
      const fetchData = async () => {
         try {
            // const fetchParams = selectedFilter === "option11" ? { type: 'K', name: NameInputValue } : { type: 'K' };

            let fetchParams = {
               page: currentPage,
               search: debouncedSearchQuery,
               sortBy: sorting.length ? sorting[0]?.name : 'name',
               sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'asc',
               ...(shouldShowCompanyDropdown && { companyIds: user?.loginhistory?.companyId }),
            };
            let filters = [];

            if (NameInputValue && NameselectedFilter) {
               filters.push({ name: 'name', value: NameInputValue, type: NameselectedFilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }
            if (ordinalInputValue && ordinalselectedFilter) {
               filters.push({ name: 'ordinal', value: ordinalInputValue, type: ordinalselectedFilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }

            const response = await dispatch(getBrand(fetchParams));

            // Check if response is an array
            if (response?.length > 0 && Array.isArray(response)) {
               setBrandData(response);
            } else {
               console.warn('No data found. Setting empty array.');
               // setNameInputValue("");
               setBrandData([]); // ✅ Prevents 'undefined' error
            }
         } catch (error) {
            console.error('Error fetching data:', error);
            setBrandData([]); // ✅ Ensure an empty array is set
         }
      };
      fetchData();
   }, [dispatch, NameInputValue, ordinalInputValue]);

   useEffect(() => {
      setData([...BrandData]);
   }, [BrandData]);

   const [isDropdownOpen, setDropdownOpen] = useState(false);

   const toggleDropdown = () => {
      setDropdownOpen(!isDropdownOpen);
   };

   const [selectedColumn, setSelectedColumn] = useState(null);

   const handleImageClick = (columnHeader) => {
      setSelectedColumn(columnHeader); // Store which column was clicked
      setDropdownOpen(true);
      if (selectedColumn?.props?.children === 'NAME') {
         setInputValue(NameInputValue);
      }
      if (selectedColumn?.props?.children === 'ORDINAL') {
         setInputValue(ordinalInputValue);
      }
      // setIsModalOpen(true); // Open modal
   };

   const handleFilterClick = () => {
      const selectedKey = selectedColumn?.props?.children;

      const inputSetters = {
         NAME: setNameInputValue,
         ORDINAL: setordinalInputValue,
      };

      const selectedoption = {
         NAME: setNameselectedFilter,
         ORDINAL: setordinalselectedFilter,
      };

      if (selectedKey && inputSetters[selectedKey]) {
         inputSetters[selectedKey](inputValue); // Assign value only on button click
      }

      if (selectedKey && selectedoption[selectedKey]) {
         selectedoption[selectedKey](selectedFilter); // Assign value only on button click
      }

      setDropdownOpen(false);
   };

   const handlecancelClick = () => {
      if (selectedColumn?.props?.children === 'NAME') {
         setNameInputValue('');
         setNameselectedFilter('');
      } else if (selectedColumn?.props?.children === 'ORDINAL') {
         setordinalInputValue('');
         setordinalselectedFilter('');
      } else if (selectedColumn?.props?.children === 'STATUS') {
         setstatusInputValue('');
      }
      setSelectedFilter('');
      setDropdownOpen(false);
   };

   const getLeftValue = (column) => {
      switch (column) {
         case 'NAME':
            return '3%';
         case 'ORDINAL':
            return '30%';
         case 'STATUS':
            return '60%';
         default:
            return '60%';
      }
   };
   const [expanded, setExpanded] = useState(false);
   const wrapperRef = useRef();
   useOutsideClick({
      ref: wrapperRef,
      handler: () => {
         if (searchQuery === '') setExpanded(false);
      },
   });

   return (
      <>
         <Box bg={backgroundColor} w="100%">
            <Flex
               width={{ base: '100%', md: 'auto' }}
               mb="8px"
               px={{ base: '1px', md: '25px' }}
               justifyContent="space-between"
               align="center"
               overflowX="auto"
               flexWrap="nowrap"
               gap={3}>
               {/* Left Section: Title + Add New Button */}
               <Flex align="center" gap={4} flexShrink={0}>
                  <Text
                     color={textColor}
                     ml={{ base: '8px', md: 0 }}
                     fontSize={{ base: '17px', lg: '22px' }}
                     fontWeight="700"
                     lineHeight="100%">
                     Brand
                  </Text>
               </Flex>

               {/* Right Section: Pagination + Limit + Search + Menu */}
               <Flex align="center" gap={2} flexShrink={0} p={3}>
                  {!isMobileOrTablet && (Admin || brandRight?.add) && user && !user.isExpired && (
                     <button
                        onClick={() => {
                           setCurrentRow({});
                           setIsEditMode(false);
                           onOpen();
                        }}
                        className={`group relative flex items-center justify-center gap-3 py-2 px-7 rounded-xl font-medium shadow-lg transition-all duration-300 ease-out transform hover:-translate-y-1 focus:outline-none focus:ring-4 active:scale-95 overflow-hidden border ${
                           isDark
                              ? 'bg-gradient-to-br from-cyan-400 to-blue-500 hover:from-cyan-300 hover:to-blue-400 text-white shadow-cyan-500/30 hover:shadow-2xl hover:shadow-cyan-400/40 focus:ring-cyan-200/50 border-cyan-300/30'
                              : 'bg-gradient-to-br from-emerald-400 to-teal-500 hover:from-emerald-300 hover:to-teal-400 text-white shadow-emerald-500/30 hover:shadow-2xl hover:shadow-emerald-400/40 focus:ring-emerald-200/70 border-emerald-300/50'
                        }`}>
                        {/* Gradient overlay on hover */}
                        <span
                           className={`absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 transform translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-in-out ${
                              isDark ? 'via-cyan-100/20' : 'via-white/30'
                           }`}></span>

                        {/* Icon container with background */}
                        <span
                           className={`relative flex items-center justify-center w-6 h-6 rounded-lg backdrop-blur-sm transition-all duration-300 ${
                              isDark
                                 ? 'bg-cyan-100/20 group-hover:bg-cyan-100/30'
                                 : 'bg-white/20 group-hover:bg-white/30'
                           }`}>
                           <svg
                              className="w-4 h-4 transition-transform duration-300 group-hover:rotate-90"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 4v16m8-8H4" />
                           </svg>
                        </span>

                        <span className="relative text-base font-semibold">Add New</span>
                     </button>
                  )}

                  {/* Search Field */}
                  <MotionFlex
                     ref={wrapperRef}
                     align="center"
                     bg={bg}
                     borderRadius="full"
                     cursor="pointer"
                     px={expanded ? 3 : 0}
                     w={expanded ? '200px' : '40px'}
                     h="40px"
                     transition="all 0.3s ease"
                     onClick={() => setExpanded(true)}>
                     <MotionSearchIcon
                        color={icon}
                        animate={{ rotate: expanded ? 0 : 90 }}
                        transition={{ duration: 0.3 }}
                        style={{
                           marginRight: expanded ? '8px' : '10px',
                           marginLeft: expanded ? '0' : '10px',
                        }}
                     />
                     {expanded && (
                        <Input
                           variant="unstyled"
                           placeholder="Search..."
                           value={searchQuery}
                           color={icon}
                           // onChange={(e) => setSearchQuery(e.target.value)}
                           onChange={handleSearchChange}
                           autoFocus
                        />
                     )}
                  </MotionFlex>
               </Flex>

               {/* Mobile Floating Add New Button */}
               {isMobileOrTablet && (Admin || brandRight?.add) && user && !user.isExpired && (
                  <button
                     onClick={() => {
                        setCurrentRow({});
                        setIsEditMode(false);
                        onOpen();
                     }}
                     className={`group relative flex items-center justify-center gap-3 py-2 px-7 rounded-xl font-medium shadow-lg transition-all duration-300 ease-out transform hover:-translate-y-1 focus:outline-none focus:ring-4 active:scale-95 overflow-hidden border ${
                        isDark
                           ? 'bg-gradient-to-br from-cyan-400 to-blue-500 hover:from-cyan-300 hover:to-blue-400 text-white shadow-cyan-500/30 hover:shadow-2xl hover:shadow-cyan-400/40 focus:ring-cyan-200/50 border-cyan-300/30'
                           : 'bg-gradient-to-br from-emerald-400 to-teal-500 hover:from-emerald-300 hover:to-teal-400 text-white shadow-emerald-500/30 hover:shadow-2xl hover:shadow-emerald-400/40 focus:ring-emerald-200/70 border-emerald-300/50'
                     }`}>
                     {/* Gradient overlay on hover */}
                     <span
                        className={`absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 transform translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-in-out ${
                           isDark ? 'via-cyan-100/20' : 'via-white/30'
                        }`}></span>

                     {/* Icon container with background */}
                     <span
                        className={`relative flex items-center justify-center w-6 h-6 rounded-lg backdrop-blur-sm transition-all duration-300 ${
                           isDark ? 'bg-cyan-100/20 group-hover:bg-cyan-100/30' : 'bg-white/20 group-hover:bg-white/30'
                        }`}>
                        <svg
                           className="w-4 h-4 transition-transform duration-300 group-hover:rotate-90"
                           fill="none"
                           stroke="currentColor"
                           viewBox="0 0 24 24">
                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 4v16m8-8H4" />
                        </svg>
                     </span>

                     <span className="relative text-base font-semibold">Add New</span>
                  </button>
               )}
            </Flex>

            {/* Table Rendering */}
            {isLoading ? (
               <Loader />
            ) : (
               <DynamicTable
                  right={brandRight}
                  table={table}
                  data={paginatedData}
                  handleViewSingleData={handleViewSingleData}
                  handleImageClick={handleImageClick}
                  toggleDropdown={toggleDropdown}
                  filter={filter}
                  emptyMessage="No brand data found"
                  onEditClick={(row) => {
                     setCurrentRow(row);
                     setIsEditMode(true);
                     onOpen();
                     setIsOpenSingleView(false);
                  }}
                  onDeleteClick={(id) => {
                     handleDeleteClick(id);
                     setIsOpenSingleView(false);
                  }}
                  canDelete={true}
                  columnVisibility={columnVisibility}
                  columnsData={columnsData}
                  sorting={sorting}
                  limit={limit}
                  setCurrentRow={setCurrentRow}
                  onOpen={onOpen}
                  setIsEditMode={setIsEditMode}
                  setIsOpenSingleView={setIsOpenSingleView}
                  setDeleteDialogOpen={setDeleteDialogOpen}
                  setSelectedRowId={setSelectedRowId}
                  // debouncedSearchQuery={debouncedSearchQuery}
               />
            )}
            <BrandMasterForm
               isOpen={isOpen}
               onClose={onClose}
               isEditMode={isEditMode}
               currentRow={currentRow}
               onSave={handleSave}
            />

            <style jsx>{`
               .editable-row {
                  position: relative;
                  background: ${useColorModeValue('white', 'gray.700')};
                  transition: background 0.3s ease;
               }

               .editable-row:hover {
                  background: ${useColorModeValue('gray.100', 'gray.600')};
               }

               .editable-row .edit-icon-container {
                  display: none;
               }

               .editable-row:hover .edit-icon-container {
                  display: block;
                  position: absolute;
                  right: 10px;
                  top: 50%;
                  transform: translateY(-50%);
               }
            `}</style>
            <DeleteDialog
               isDeleteDialogOpen={isDeleteDialogOpen}
               setDeleteDialogOpen={setDeleteDialogOpen}
               handleDelete={handleDelete}
               title="Brand"
            />
         </Box>
         {isDropdownOpen && selectedColumn?.props?.children && (
            <Box
               position="absolute"
               top="350px" // Dropdown below image
               left={getLeftValue(selectedColumn?.props?.children)}
               width="auto"
               bg={backgroundColor}
               border="1px solid gray"
               borderRadius="5px"
               boxShadow="md"
               p="2"
               mt="2"
               zIndex="1000000000"
               transition="all 0.2s ease-in-out">
               <Grid templateColumns="repeat(1, 1fr)" gap={4} p={4}>
                  <Grid justifyContent="center" color={textColor} fontSize="2xl" fontWeight="medium">
                     <label>Select {selectedColumn.props.children.toLowerCase()} Filter</label>
                  </Grid>
                  <hr></hr>
                  {['CREATED DATE', 'BALANCE', 'GST PERCENTAGE', 'HSN', 'ORDINAL', 'ACCOUNT NO'].includes(
                     selectedColumn?.props?.children,
                  ) ? (
                     <GridItem display="flex" alignItems="center">
                        <FormLabel htmlFor="dropdown" width="60%" color={textColor}>
                           Select option
                        </FormLabel>
                        <Select
                           id="dropdown"
                           placeholder="Choose an option"
                           color={textColor}
                           onChange={(e) => setcreateddateselectedFilter(e.target.value)} // Update selected filter
                        >
                           <option value="equal">Equal (=)</option>
                           <option value="less_than">Less than (&lt;)</option>
                           <option value="less_than_equal">Less than or equal (&le;)</option>
                           <option value="greater_than">Greater than (&gt;)</option>
                           <option value="greater_than_equal">Greater than or equal (&le;)</option>
                        </Select>
                     </GridItem>
                  ) : (
                     <GridItem display="flex" alignItems="center">
                        <FormLabel htmlFor="dropdown" width="60%" color={textColor}>
                           Select option
                        </FormLabel>
                        <Select
                           id="dropdown"
                           placeholder="Choose an option"
                           color={textColor}
                           onChange={(e) => setSelectedFilter(e.target.value)} // Update selected filter
                        >
                           <option value="1">Starts With</option>
                           <option value="2">Ends With</option>
                           <option value="3">Contains</option>
                           <option value="4">Equal</option>
                           <option value="5">Empty</option>
                           <option value="6">Does Not Start With</option>
                           <option value="7">Does Not End With</option>
                           <option value="8">Does Not Contain</option>
                           <option value="9">Not Equal</option>
                           <option value="10">Not Empty</option>
                           <option value="11">Like</option>
                        </Select>
                     </GridItem>
                  )}
                  <GridItem display="flex" alignItems="center">
                     <FormLabel htmlFor="input1" width="60%" color={textColor}>
                        Enter the value
                     </FormLabel>
                     <Input
                        id="input2"
                        color={textColor}
                        placeholder="Enter last name"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                     />
                  </GridItem>
                  <GridItem mt="20px" display="flex" justifyContent="space-between">
                     <Button colorScheme="blue" width="45%" onClick={handleFilterClick}>
                        Filter
                     </Button>
                     <Button colorScheme="red" width="45%" onClick={handlecancelClick}>
                        cancel
                     </Button>
                  </GridItem>
               </Grid>
            </Box>
         )}
      </>
   );
}
